import { useMutation } from "@tanstack/react-query";
import type { ExtractDocumentRequest } from "Infrastructure/Api/Api";
import { postDocumentsExtract } from "Infrastructure/Api/Api";

export function useExtractDocumentMutation() {
	return useMutation({
		mutationFn: (request: ExtractDocumentRequest) =>
			postDocumentsExtract(request),
	});
}
